import React from 'react';

interface CookieBannerProps {
  onAccept: () => void;
  onDecline: () => void;
  onPrivacyClick: () => void;
}

const CookieBanner: React.FC<CookieBannerProps> = ({ onAccept, onDecline, onPrivacyClick }) => {
  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50 p-4"
      role="dialog"
      aria-label="Cookie consent"
    >
      <div className="max-w-3xl mx-auto glass-card border border-white/15 px-5 py-4 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <div className="flex-1 min-w-0">
          <p className="text-white/80 text-sm leading-relaxed">
            🍪 We use cookies for ads (Google AdSense) so this tool stays free. Your Instagram files are{' '}
            <span className="text-white font-semibold">never uploaded</span> — everything runs in your browser.{' '}
            <button
              onClick={onPrivacyClick}
              className="text-white/50 hover:text-white underline transition-colors"
            >
              Privacy Policy
            </button>
          </p>
        </div>
        <div className="flex gap-2 flex-shrink-0">
          <button
            onClick={onDecline}
            className="text-xs px-4 py-2 rounded-full border border-white/15 text-white/50 hover:text-white hover:border-white/30 transition-all"
          >
            Decline
          </button>
          <button
            onClick={onAccept}
            className="text-xs px-5 py-2 rounded-full btn-gradient text-white font-semibold"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
